import React, { useEffect, useRef } from 'react';
import { CloseCircleIcon } from '../../../content/svg-component';
import { Conditional } from '../../../utils/utility';
import { FormattedMessage } from 'react-intl';
import ReactPortal from '../../../utils/utility/react-portal';
import './modal.css';

export const Modal = ({
  children,
  isOpen,
  onClose,
  title,
  detail,
  titleClass,
  detailClass,
  size,
  isBack = false,
  onBack,
  customContent = false,
  modlaSizeClass = '',
  modalWidth = 'col-12 col-xl-10 col-sm-11',
}) => {
  useEffect(() => {
    document.getElementById('root').style.overflow = 'unset';
    const closeOnEscapeKey = (event) =>
      event.key === 'Escape' ? onClose() : null;
    document.body.addEventListener('keydown', closeOnEscapeKey);
    document.getElementById('react-portal-modal-container');
    return () => {
      document.body.removeEventListener('keydown', closeOnEscapeKey);
      document.getElementById('root').style.overflow = 'auto';
    };
  }, [onClose]);

  const ModalContent = ({
    title,
    detail,
    titleClass,
    detailClass,
    isBack = false,
    onBack,
    customContent = false,
    children,
    onClose,
  }) => {
    if (customContent) return children;
    return (
      <div
        className={`bg-white my-2 ${modalWidth}`}
        style={{ borderRadius: '10px' }}
      >
        <div className="p-4">
          <div className="col-12 d-flex flex-column px-0">
            <div className="d-flex text-center  justify-content-between font-weight-bold pb-4">
              <Conditional checkRender={isBack}>
                <div className=" d-flex cursor-pointer" onClick={onBack}>
                  <FormattedMessage id="booking.backpreviouspage" />
                </div>
              </Conditional>
              <div
                className={`d-flex flex-column align-items-center justify-content-center ${
                  !isBack && 'w-100'
                }`}
              >
                <div className={` d-flex px-0 title  ${titleClass ?? ''}`}>
                  {title ?? ''}
                </div>
                <div className={`detail font-small  px-0 ${detailClass ?? ''}`}>
                  {detail ?? ''}
                </div>
              </div>
              <div
                className={`d-flex p-0 justify-content-end align-items-start `}
              >
                <button
                  name={`modal-${title}`}
                  id={`modal-${title}`}
                  type="button"
                  className="close d-flex text-muted px-0 cursor-pointer"
                  onClick={onClose}
                >
                  <CloseCircleIcon size={25} />
                </button>
              </div>
            </div>
            {children}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {isOpen && (
        <ReactPortal wrapperId="react-portal-modal-container">
          <div className="portal">
            <div // this <div> isn't actually a child of the <span> above. Magic portal.
              className="portal-modal overlay "
            >
              <div className={` portal-modal-content `}>
                <div
                  className={`d-flex justify-content-center align-items-center ${
                    modlaSizeClass ? modlaSizeClass : 'defualt-modal-width'
                  }`}
                >
                  <ModalContent
                    children={children}
                    detail={detail}
                    detailClass={detailClass}
                    onBack={onBack}
                    onClose={onClose}
                    size={size}
                    title={title}
                    titleClass={titleClass}
                    customContent={customContent}
                    isBack={isBack}
                  />
                </div>
              </div>
            </div>
          </div>
        </ReactPortal>
      )}
    </>
  );
};

export default Modal;
